import axios from 'axios';
import { API_URL } from '../constants/api';

class LPATestService {
  /**
   * Submit a new LPA test request
   * @param {Object} formData - The LPA test request form data
   * @returns {Promise} - The API response
   */
  async submitLPATestRequest(formData) {
    try {
      const response = await axios.post(`${API_URL}/screening/submit-lpa-test`, formData);
      return response.data;
    } catch (error) {
      console.error('Error submitting LPA test request:', error);
      throw error;
    }
  }

  /**
   * Get LPA test details by id
   * @param {string} id - The LPA test ID
   * @returns {Promise} - The API response
   */
  async getLPATest(id) {
    try {
      const response = await axios.get(`${API_URL}/screening/get-lpa-test/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error getting LPA test details:', error);
      throw error;
    }
  }

  /**
   * Get LPA tests for the current user
   * @returns {Promise} - The API response
   */
  async getLPATests() {
    try {
      const response = await axios.get(`${API_URL}/screening/get-lpa-tests`);
      return response.data;
    } catch (error) {
      console.error('Error getting LPA tests:', error);
      throw error;
    }
  }
}

// Create a singleton instance
const instance = new LPATestService();
export default instance;